import { Component, OnInit } from '@angular/core';
import { SpreadsheetConversion, SpreadsheetConversionStatus } from 'app/models/spreadsheet-conversion';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { SpreadsheetConversionService } from 'app/services/spreadsheet-conversion.service';
import { UserService } from 'app/services/user.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { basename } from 'path';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-data-imports',
  templateUrl: './data-imports.component.html',
  styleUrls: ['./data-imports.component.scss']
})
export class DataImportsComponent implements OnInit {

  tableLimitSelect = [5, 10, 20, 30, 50, 100];

  spreadsheetConversions: SpreadsheetConversion[] = [];
  spreadsheetConversionToDelete: SpreadsheetConversion = null;

  isLoadingSpreadsheetImports: boolean = false;
  selectedSpreadsheetImportsTableLimit: number = 5;

  constructor(private spreadsheetConversionService: SpreadsheetConversionService, 
              private ecodocsTitleService: EcoDocsTitleService, public userService: UserService,
              private toastService: ToastService) {

    this.userService.currentUser.subscribe(user => {
      if (user) {
        (window as any).Echo.private(`${user.company_id}.user.${user.id}`).listen('SpreadsheetConversionChanged', (e) => {
          Object.keys(e.changes).forEach((spreadsheetConversionId) => {
            console.log(spreadsheetConversionId);
            let s = this.spreadsheetConversions.find((v) => v.id == +spreadsheetConversionId);
            if (s) {
              Object.keys(e.changes[spreadsheetConversionId]).forEach((key) => {
                s[key] = e.changes[spreadsheetConversionId][key];
              });
            }
          });
          this.spreadsheetConversions = [...this.spreadsheetConversions];
        });
        (window as any).Echo.private(`${user.company_id}.user.${user.id}`).listen('SpreadsheetConversionDeleted', (e) => {
          let s = this.spreadsheetConversions.filter((v) => v.id != +e.deleted_id);
          this.spreadsheetConversions = [...s];
        });
      }
    });
  }

  ngOnInit(): void {
    this.ecodocsTitleService.setTitle('Data Imports', false);

    this.refreshSpreadsheetConversions();
  }

  innerWidth() {
    return window.innerWidth;
  }

  refreshSpreadsheetConversions() {
    this.isLoadingSpreadsheetImports = true;
    this.spreadsheetConversionService.list().pipe(finalize(() => {
      this.isLoadingSpreadsheetImports = false;
    })).subscribe((s) => {
      this.spreadsheetConversions = s;
    }, () => {
      this.toastService.error('Error getting spreadsheet data imports!');
    });
  }

  spreadsheetNameComparator(valueA, valueB, rowA: SpreadsheetConversion, rowB: SpreadsheetConversion, sortDirection) {
    let rowAField = basename(rowA.path) + ' > ' + rowA.selected_worksheet;
    let rowBField = basename(rowB.path) + ' > ' + rowB.selected_worksheet;
    
    return rowAField.localeCompare(rowBField);
  }

  public get spreadsheetConversionStatus() : typeof SpreadsheetConversionStatus {
    return SpreadsheetConversionStatus;
  }

  getSpreadsheetConversionStatusLabel(status: SpreadsheetConversionStatus) {
    var result = '';
    switch (status) {
      case SpreadsheetConversionStatus.STATUS_PENDING:
        result = 'Pending';
        break;
        case SpreadsheetConversionStatus.STATUS_IN_PROGRESS:
          result = 'In Progress';
          break;
        case SpreadsheetConversionStatus.STATUS_COMPLETED:
          result = 'Completed';
          break;
        case SpreadsheetConversionStatus.STATUS_DELETING:
            result = 'Deleting';
            break;
      }

    return result;
  }

  onUndoConversion() {
    this.isLoadingSpreadsheetImports = true;
    this.spreadsheetConversionService.undoConversionData(this.spreadsheetConversionToDelete.id).pipe(finalize(() => {
      this.isLoadingSpreadsheetImports = false;
    })).subscribe(() => {
      this.toastService.success('Data undo initiated!');
      this.refreshSpreadsheetConversions();
    }, () => {
      this.toastService.error('Error undoing data!');
    });
  }
}
